import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Divider,
  TextField,
} from "@material-ui/core";
import { withRouter, useParams, useLocation } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import TitleContainer from "../../LogoLinks/TitleContainer";

// import Axios from "axios";

import ReactHtmlParser from "html-react-parser";

import { useHistory } from "react-router-dom";
import LayoutContainer from "../../../components/LayoutsContainer";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "3vh 0vw",
  },
  achievementContainer: {
    marginTop: theme.spacing(5),
  },
  readmoreBtn: {
    borderRadius: 100,
  },
  frame: {
    height: "100%",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      height: "50vh",
    },
  },
  captcha: {
    borderRadius: 10,
    backgroundImage: `linear-gradient(45deg, #b3b3b3 25%, #3a7cb3 25%, #3a7cb3 50%, #b3b3b3 50%, #b3b3b3 75%, #3a7cb3 75%, #3a7cb3 100%)`,
    backgroundSize: "28.28px 28.28px",
    padding: "1vh 2vh",
    color: "white",
    [theme.breakpoints.down("md")]: {
      padding: "0.5vh 1vh",
    },
  },
  maintitleContainer: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(5),
    },
  },
  maintitle: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(2),
    },
  },
}));

const GramSchemesLayout = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigate = (link, extenral) => {
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(link);
  };
  const [state, setState] = React.useState({
    name: "",
    companyname: "",
    email: "",
    phone: "",

    address: "",
    country: "",
  });
  const [captcha, setCaptcha] = React.useState({
    value: "",
    enteredValue: "",
  });
  const [error, setError] = React.useState("");

  const [requestSuccess, setRequestSuccess] = React.useState(null);

  const handleChange = (e) => {
    setError("");
    const name = e.target.name;
    const value = e.target.value;

    setState({
      ...state,
      [name]: value,
    });
  };
  const handleCaptchaChange = (e) => {
    e.preventDefault();
    setError("");

    setCaptcha({
      ...captcha,
      enteredValue: e.target.value,
    });
  };

  React.useEffect(() => {
    function keyGen(keyLength) {
      var i,
        key = "",
        characters =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var charactersLength = characters.length;
      for (i = 0; i < keyLength; i++) {
        key += characters.substr(
          Math.floor(Math.random() * charactersLength + 1),
          1
        );
      }
      setCaptcha({
        ...captcha,
        value: key,
      });
      return key;
    }
    keyGen(6);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    var mailregex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // console.log(re.test(this.state.email));
    var mobileRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (!mailregex.test(state.email)) {
      setError("email");
    } else if (!mobileRegex.test(state.phone)) {
      setError("phone");
    } else if (captcha.value !== captcha.enteredValue) {
      // console.log(captcha, "captcha");
      setError("captcha");
    } else {
      const data = {
        name: state.name,
        email: state.email,
        phone: state.phone,
      };

      // Axios req

      // Axios.post("url", data)
      //   .then((res) => setRequestSuccess(true))
      //   .catch((err) => {
      //     setRequestSuccess(false);
      //     setError("requestfail");
      //   });
    }
  };
  const { name, email, mobile } = data.inputs;
  return (
    <div className={classes.root}>
      <LayoutContainer>
        <div>
          <Grid container direction="column" alignItems="flex-start">
            <Grid item className={classes.TitleContainer}>
              <TitleContainer title={data.title} />
            </Grid>
          </Grid>
        </div>
        <div className={classes.achievementContainer}>
          {data !== null && data !== undefined && (
            <Grid container justify="space-evenly" spacing={2}>
              <Grid itel lg={6} className={classes.gridItemContainer}>
                <iframe
                  title="map"
                  src={data.mapUrl}
                  className={classes.frame}
                ></iframe>
              </Grid>
              <Grid itel lg={6} className={classes.gridItemContainer}>
                <Box m={3}>
                  <div className={classes.contactContainer}>
                    <div className={classes.contactDescription}>
                      <Typography variant="body1">
                        {/* {ReactHtmlParser(data.description)} */}
                      </Typography>
                    </div>
                    <div className={classes.formContainer}>
                      {requestSuccess !== true ? (
                        <form
                          onError={(e) => console.log(e)}
                          onSubmit={(e) => handleSubmit(e)}
                        >
                          <Grid container spacing={2}>
                            {error === "requestfail" && (
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Alert severity="error">
                                  An Error occured, Please try again later.
                                </Alert>
                              </Grid>
                            )}
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                size="small"
                                label={name.label}
                                required={true}
                                name="name"
                                value={state.name}
                                onChange={(e) => handleChange(e)}
                              />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                size="small"
                                inputMode="email"
                                label={email.label}
                                required={true}
                                error={error === "email"}
                                helperText={
                                  error === "email" && "Email is not valid"
                                }
                                name="email"
                                value={state.email}
                                onChange={(e) => handleChange(e)}
                              />
                            </Grid>{" "}
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                size="small"
                                label={mobile.label}
                                inputMode="numeric"
                                required={true}
                                error={error === "phone"}
                                helperText={
                                  error === "phone" &&
                                  "Phone Number is not valid"
                                }
                                // type="number"
                                name="phone"
                                value={state.phone}
                                onChange={(e) => handleChange(e)}
                              />
                            </Grid>
                            <Grid item lg={8} md={8} sm={8} xs={8}>
                              <TextField
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                label="Enter Captcha"
                                required={true}
                                // type="number"
                                error={error === "captcha"}
                                helperText={
                                  error === "captcha" &&
                                  "Captcha does not match"
                                }
                                name="captcha"
                                value={state.captcha}
                                onChange={(e) => handleCaptchaChange(e)}
                              />
                            </Grid>
                            <Grid
                              item
                              lg={4}
                              md={4}
                              sm={4}
                              xs={4}
                              container
                              alignItems="center"
                              justify="center"
                              className={classes.captchabg}
                            >
                              <Typography
                                variant="h6"
                                className={classes.captcha}
                              >
                                {captcha.value}
                              </Typography>
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Button
                                fullWidth
                                color="primary"
                                type="submit"
                                variant="contained"
                              >
                                {data.btnTitle}
                              </Button>
                            </Grid>
                          </Grid>
                        </form>
                      ) : (
                        <Alert severity="success">{data.successMsg}</Alert>
                      )}
                    </div>
                  </div>
                </Box>
              </Grid>
            </Grid>
          )}
        </div>
      </LayoutContainer>
    </div>
  );
};
export default GramSchemesLayout;
